import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PropertyIntakeModalService } from '../../core/services/property-intake-modal.service';

interface FooterLink {
  label: string;
  href: string;
}

@Component({
  selector: 'krc-krc-footer',
  standalone: true,
  imports: [],
  templateUrl: './krc-footer.html',
  styleUrl: './krc-footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KrcFooter {
  private readonly intakeModal = inject(PropertyIntakeModalService);

  goToPropertyIntake(): void { this.intakeModal.open(); }

  readonly year = 2026;

  // Mirrors the landing-v3 footer nav.
  readonly navItems: FooterLink[] = [
    { label: 'The Kore ADU', href: '/landing-v3#kore-adu' },
    { label: 'How It Works', href: '/landing-v3#process' },
    { label: 'Why Kore Works', href: '/landing-v3#why-kore' },
    { label: 'About Kore', href: '/landing-v3#about-kore' },
  ];
}
